module.exports = __webpack_public_path__ + "static/media/proces_06.569b2434.svg";